import { render, staticRenderFns } from "./MainAddress.vue?vue&type=template&id=531d6f6e&"
import script from "./MainAddress.vue?vue&type=script&lang=js&"
export * from "./MainAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports